import common from 'ui-react-common';

const config = common.config;

const generateValidity = {
    state: (gaResponse) => {
        const resolvedState = typeof gaResponse === 'object' ? gaResponse.state : gaResponse;

        if (!resolvedState) {
            return {
                isValid: false,
            };
        }

        const validState = config.global.invalidStates.indexOf(resolvedState) === -1;
        if (!validState) {
            return {
                isValid: false,
                inputAttr: {
                    pattern: 'invalidState',
                },
            };
        }
        return true;
    },
    city: (gaResponse) => gaResponse.hasValidCity,
    zip: (gaResponse) => gaResponse.hasValidZip,
    streetAddress: (gaResponse) => gaResponse.hasValidStreetAddress,
};

export const addressValidation = {
    validateOn: ['blur'],
    mustNotBePoBox: true,
    mustBeAddress: true,
    required: true,
    message: {
        default: 'Please enter your address',
    },
};

export const cityValidation = {
    validateOn: ['blur'],
    validationRegex: /.*/,
    required: true,
    message: {
        default: 'Please enter a city',
    },
};

export const googleAddressValidation = {
    validateOn: ['keyup'],
    required: true,
    message: {
        default: 'Please enter a valid address',
        pattern: {
            invalidState: 'We currently do not lend in this state',
        },
    },
    checkValidity: (value, formSubmit, event) => {
        const { name, gaResponse } = event.target;

        if (!gaResponse) {
            return { isValid: true };
        }

        const fields = ['city', 'state', 'zip', 'streetAddress'];

        return fields
            .map((field) => {
                const matchingValidationFn = generateValidity[field];

                if (typeof matchingValidationFn === 'function') {
                    return matchingValidationFn(gaResponse);
                }
            })
            .reduce(
                (acc, cur) => {
                    const validityData = typeof cur === 'boolean' ? { isValid: cur } : cur;
                    validityData.isValid = acc.isValid && validityData.isValid;

                    return Object.assign({}, acc, validityData);
                },
                { isValid: true }
            );
    },
};

export const stateValidation = {
    validateOn: ['keyup'],
    required: true,
    message: {
        default: 'Please select a valid state',
        pattern: {
            invalidState: 'We currently do not lend in this state',
        },
    },
    checkValidity: generateValidity.state,
};

export const zipValidation = {
    validateOn: ['blur'],
    validationRegex: /^\d{5}$/,
    required: true,
    message: {
        default: 'Please enter a 5 digit zip code',
    },
};

export const aptNumberValidation = {
    validateOn: ['blur'],
    validationRegex: config.global.validation.patterns.address,
    required: false,
    message: {
        default: 'Please enter a valid apt number',
    },
};
